import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";

export const useLanguages = () => {
  const [languages, setLanguages] = useState([]);
  const [fetching, setFetching] = useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => { await getLanguages() })();
  }, []);

  const getLanguages = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Languages}`, 
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setLanguages(response.data.data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  return { languages, fetching, getLanguages };
};
